import { useEffect } from 'react';
import { useParams, Outlet, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SUPPORTED_LANGUAGES = ['en', 'es', 'fr', 'de', 'it', 'tr', 'ar', 'bn'];

export default function LanguageRouteWrapper() {
  const { lang } = useParams<{ lang: string }>();
  const { i18n } = useTranslation();

  // If the language in the URL isn't supported, redirect to the root
  if (lang && !SUPPORTED_LANGUAGES.includes(lang)) {
    return <Navigate to="/" replace />;
  }

  useEffect(() => {
    if (lang && SUPPORTED_LANGUAGES.includes(lang) && i18n.resolvedLanguage !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return <Outlet />;
}
